<template>
  <div id="user-view" class="c-user c-page">
    <div class="c-page__inner l-columns-container l-columns-container--outmost">
      <div class="l-tablet-column--4">
        <h1 class="f-headline">
          <strong>Dine</strong> oplysninger
        </h1>
      </div>

      <div class="l-tablet-column--6">
        <form class="c-form general-form">
          <!-- <div class="c-form__element user-block">
            <h2 class="c-form__label">
              Email
            </h2>

            <p class="c-form__value user-info">
              {{ user.email }}
              <br>
              <a
                href="mailto:info@foljeton.dk"
                class="f-italic f-small"
              >
                Skriv til os hvis du vil ændre din mail
              </a>
            </p>
          </div>-->

          <label class="c-form__element user-block">
            <h2 class="c-form__label">Email</h2>
            <input type="text" :placeholder="user.email" disabled />
            <a
              href="mailto:kontakt@foljeton.dk"
              class="f-italic f-small"
            >Skriv til os, hvis du vil ændre din mail.</a>
          </label>

          <label class="c-form__element user-block">
            <h2 class="c-form__label">Navn</h2>
            <input v-model="user.name" type="text" />
          </label>

          <label class="c-form__element user-block">
            <h2 class="c-form__label">Password</h2>
            <input
              v-model="password"
              value="*******"
              type="password"
              @change="changedPasswordEvent()"
            />
          </label>

          <label class="c-form__submit" @click.prevent="saveUser()">
            <!-- <ArrowLink title="Gem" /> -->
            <SpinnerButton
              ref="saveuser"
              class="c-form__submit"
              cta="Gem"
              action="Gemmer"
              @clickaction="saveUser"
            />

            <input type="submit" value="Gem" />
          </label>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerButton from "@/components/SpinnerButton.vue";

export default {
  name: "User",

  components: {
    SpinnerButton
  },
  data() {
    return {
      user: this.$route.meta.user,
      originalUser: null,
      changedPassword: false,
      password: "000000"
    };
  },
  mounted() {
    console.log(this.user);
    this.originalUsername = this.user.name;
    this.$userService.refreshLocalUser().then(user => {
      console.log("user updated");
    });
    //this.user = this.$route.meta.user
  },
  methods: {
    saveUser(event) {
      console.log("save");
      if (event) event.preventDefault();
      const promises = [];

      if (this.originalUsername != this.user.name) {
        const usernamePromise = this.$userService.setUsername(this.user.name);
        promises.push(usernamePromise);
      }
      if (this.changedPassword) {
        const passwordPromise = this.$userService.setPassword(this.password);

        promises.push(passwordPromise);
        console.log("password", this.password);
      }
      console.log("promises " + promises.length);

      if (promises.length < 1) {
        console.log("no change");
        //console.log(this.$refs, this.$refs.saveuser);
        setTimeout(() => {
          this.$refs.saveuser.reset();
        }, 800);
      } else {
        console.log(promises);
        Promise.all(promises)
          .then(values => {
            console.log("then");
            this.$userService.refreshLocalUser().then(user => {
              this.user = user;
              this.$refs.saveuser.reset();
            });
          })
          .catch(function(err) {
            console.log("catch");
            this.$userService.refreshLocalUser().then(user => {
              this.user = user;
              this.$refs.saveuser.reset();
            });

            console.log(err);
          });
      }
    },
    changedPasswordEvent() {
      this.changedPassword = true;
    }
  }
};
</script>